import eraseCookie from "./eraseCookie";

export default function clearCache() {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i += 1)
    eraseCookie(cookies[i].split("=")[0]);
  document.cookie = ``;
}
